require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./blog-a-new-course-comes-to-code-fellows-the-front-end-development-accelerator.json") })
        }
      }, "path---blog-a-new-course-comes-to-code-fellows-the-front-end-development-accelerator");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---blog-a-new-course-comes-to-code-fellows-the-front-end-development-accelerator!./.cache/json/blog-a-new-course-comes-to-code-fellows-the-front-end-development-accelerator.json
// module id = 578
// module chunks = 231608221292675